__turbopack_context__.v({
  "button-highlight": "_5NAplW_button-highlight",
  "container": "_5NAplW_container",
  "pill": "_5NAplW_pill",
  "root": "_5NAplW_root",
  "tabCount": "_5NAplW_tabCount",
  "tabHighlight": "_5NAplW_tabHighlight",
  "tabLabel": "_5NAplW_tabLabel",
  "tabLabelInner": "_5NAplW_tabLabelInner",
});
